export enum MembershipStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED',
  Resigned = 'RESIGNED',
}
